'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var New = function New(element) {
  _classCallCheck(this, New);

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Nieuw',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }, {
      onclick: function onclick() {
        history.forward();
      },
      icon: '\uE01A'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/start/');
      },
      icon: '\uE08A'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var a1 = document.createElement('a');
  a1.className = 'icon button';
  a1.innerHTML = 'Persoon';
  a1.onclick = function () {
    window.PRIM.navigate('/people/');
  };
  var span1 = document.createElement('span');
  span1.innerHTML = '\uE12C';
  a1.insertBefore(span1, a1.childNodes[0]);

  var a2 = document.createElement('a');
  a2.className = 'icon button';
  a2.innerHTML = 'Organisatie';
  a2.onclick = function () {
    window.PRIM.navigate('/organisations/');
  };
  var span2 = document.createElement('span');
  span2.innerHTML = '\uE078';
  a2.insertBefore(span2, a2.childNodes[0]);

  /*let a3 = document.createElement('a')
  a3.className = 'icon button'
  a3.innerHTML = 'Bestand'
  a3.onclick = () => {
    window.PRIM.navigate('/files/')
  }
  let span3 = document.createElement('span')
  span3.innerHTML = '\ue063'
  a3.insertBefore(span3, a3.childNodes[0])*/

  div.appendChild(a1);
  div.appendChild(a2);
  //div.appendChild(a3)

  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = New;


//////////////////
// WEBPACK FOOTER
// ./js/modules/start/action/New.js
// module id = 19
// module chunks = 0